import { createAction } from '@ngrx/store';

export const initAppSettings = createAction('[Global App Settings] Init');
